<template>
  <div class="app-multiselect__container">
    <div class="app-multiselect__label-container" ref="labelRef" v-if="!!label">
      <span class="app-multiselect__label">
        {{ label }}
      </span>
    </div>

    <div class="app-multiselect__field-wrapper">
      <MultiselectField :multiselectRef="this" />
      <MultiselectList
        :multiselectRef="this"
        v-if="isOpen"
        :showFooter="showFooter"
        :footerText="footerText"
        :notFoundMessage="notFoundMessage"
      />
    </div>

    <span class="app-multiselect__feedback-error" v-show="status === false">
      {{ feedback }}
    </span>
  </div>
</template>

<script>
import MultiselectField from "./MultiselectField.vue";
import MultiselectList from "./MultiselectList.vue";

export default {
  components: {
    MultiselectField,
    MultiselectList,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    status: {
      type: Boolean,
      default: null,
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    footerText: {
      type: String,
      default: "Selecionar Todos",
    },
    feedback: {
      type: String,
      default: "",
    },
    datalist: {
      type: Array,
      default: () => [],
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    searchPlaceholder: {
      type: String,
      default: "Pesquise aqui",
    },
    fieldPlaceholder: {
      type: String,
      default: "Selecione",
    },
    notFoundMessage: {
      type: String,
      default: "Nenhum resultado encontrado",
    },
    emptyListAlert: {
      type: String,
      default: "A lista está vazia!",
    },
  },
  data: () => ({
    datalistFiltered: [],
    selectedItemsLocal: [],
    isOpen: false,
    isRemoveFunctionOpen: false,
  }),
  methods: {
    listenerOutClick() {
      window.addEventListener("click", (e) => {
        if (
          (!this.$el?.contains(e.target) &&
            e.target.attributes["data-name"]?.value !== "svg-remove-tag") ||
          this.$refs.labelRef === e.target ||
          this.$refs.labelRef?.contains(e.target)
        ) {
          this.isOpen = false;
          this.datalistFiltered = this.datalist;
        }
      });
    },
    updateDatalistFilteredWithDatalist(value) {
      this.datalistFiltered = [...value];
    },
    updateSelectedItemsWithSelectedItemsLocal(value) {
      JSON.stringify(this.selectedItems) !== JSON.stringify(value) &&
        this.$emit("update:selectedItems", [...value]);
    },
    updateSelectedItemsLocalWithSelectedItems(value) {
      if (JSON.stringify(value) !== JSON.stringify(this.selectedItemsLocal))
        this.selectedItemsLocal = [...value];
    },
    emitChange() {
      this.$emit("change");
    },
  },
  watch: {
    selectedItems(value) {
      this.updateSelectedItemsLocalWithSelectedItems(value);
    },
    selectedItemsLocal(value) {
      this.updateSelectedItemsWithSelectedItemsLocal(value);
      this.emitChange();
    },
    datalist(value) {
      this.updateDatalistFilteredWithDatalist(value);
    },
  },
  mounted() {
    this.listenerOutClick();

    this.datalistFiltered = [...this.datalist];
    this.selectedItemsLocal = [...this.selectedItems];
  },
};
</script>

<style lang="scss">
.app-multiselect__container {
  display: flex;
  flex-direction: column;
  width: 100%;

  .app-multiselect__label-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 4px;

    .app-multiselect__label {
      color: #4c4541;
      font-family: Raleway;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
    }
  }

  .app-multiselect__field-wrapper {
    position: relative;
  }

  .app-multiselect__feedback-error {
    margin: 1px 0 0 5px;
    color: #d32f2f;
    font-family: Raleway;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
  }
}
</style>
